import $ from 'jquery';
import { modifyState } from '~src/state';
import { showSidebarTab, hideSidebarTab } from '~src/sidebarLegacy';
import { changeTextBorderColor } from '~core/borders';

export const handleTextBorderColorChange = (hexColor) => {
  modifyState('setTextBorderColorActive', false);
  $('#color-text-border').css('background-color', hexColor);
  hideSidebarTab('colori');
  showSidebarTab('text-border');
  changeTextBorderColor(hexColor);
};
